import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'addProfiles.title',
    defaultMessage: 'PROFILES> ADD PROFILE',
  },
  userData: {
    id: 'addProfiles.userData',
    defaultMessage: 'User data',
  },
  name: {
    id: 'addProfiles.name',
    defaultMessage: 'Name',
  },
  school: {
    id: 'addProfiles.school',
    defaultMessage: 'School',
  },
  role: {
    id: 'addProfiles.role',
    defaultMessage: 'Position / Function',
  },
  evaluations: {
    id: 'addProfiles.evaluations',
    defaultMessage: 'Assessments',
  },
  catalogings: {
    id: 'addProfiles.catalogings',
    defaultMessage: 'Level of education',
  },
  email: {
    id: 'addProfiles.email',
    defaultMessage: 'Email',
  },
  password: {
    id: 'addProfiles.password',
    defaultMessage: 'Password',
  },
  passwordRule: {
    id: 'addProfiles.passwordRule',
    defaultMessage:
      'Minimum of 6 characters, from a-z, 0-9. Special characters allowed !@#$%&Amp;?',
  },
  select: {
    id: 'addProfiles.select',
    defaultMessage: 'Select...',
  },
  teacher: {
    id: 'addProfiles.teacher',
    defaultMessage: 'Teacher',
  },
  coordinator: {
    id: 'addProfiles.coordinator',
    defaultMessage: 'School Coordinator',
  },
  permissions: {
    id: 'addProfiles.permissions',
    defaultMessage: 'Permissions',
  },
  views: {
    id: 'addProfiles.views',
    defaultMessage: 'View assassement',
  },
  validateQuestions: {
    id: 'addProfiles.validateQuestions',
    defaultMessage: 'Validate Questions',
  },
  edit: {
    id: 'addProfiles.edit',
    defaultMessage: 'Edit',
  },
  cancel: {
    id: 'addProfiles.cancel',
    defaultMessage: 'Cancel',
  },
  continue: {
    id: 'addProfiles.continue',
    defaultMessage: 'Continue',
  },
  save: {
    id: 'addProfiles.save',
    defaultMessage: 'Save',
  },
  color: {
    id: 'addProfiles.color',
    defaultMessage: 'Color',
  },
  photo: {
    id: 'addProfiles.photo',
    defaultMessage: 'Photo',
  },
  errorTitle: {
    id: 'addProfiles.errorTitle',
    defaultMessage: "Couldn't save!",
  },
  errorInput: {
    id: 'addProfiles.errorInput',
    defaultMessage:
      'To register, you must fill in the field <b style = "text-transform: uppercase"> {field} </b>',
  },
  errorPasswordLength: {
    id: 'addProfiles.errorPasswordLength',
    defaultMessage: 'Password must be at least 6 characters',
  },
  errorSelect: {
    id: 'addProfiles.errorSelect',
    defaultMessage:
      'In order to register, you must select a <b style = "text-transform: uppercase"> {field} </b>',
  },
  errorEmail: {
    id: 'addProfiles.errorEmail',
    defaultMessage: 'You cannot manage your own profile permissions',
  },
  errorEmailNotValid: {
    id: 'addProfiles.errorEmailNotValid',
    defaultMessage: 'The email entered must be a valid email',
  },
  errorGeneric: {
    id: 'addProfiles.errorGeneric',
    defaultMessage: 'There was an error in the API. Try again later',
  },
  errorEvaluationsRequired: {
    id: 'addProfiles.errorEvaluationsRequired',
    defaultMessage: 'To register, you must select an Assessment',
  },
  successTitle: {
    id: 'addProfiles.successTitle',
    defaultMessage: 'User saved successfully!',
  },
});
